import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

const AppNavbar: React.FC = () => (
    <Navbar bg="dark" variant="dark" expand="md" fixed="top">
        <Container fluid>
            <Navbar.Brand href="/">
                <img
                    alt=""
                    src="https://ik.imagekit.io/8hyzqg57if/9B9174D4-F36F-43BD-ADBF-8DA55992C61B.png?updatedAt=1731584100006"
                    width="30"
                    className="d-inline-block align-top"
                />
                {' '}
                Spinnate
            </Navbar.Brand>
        </Container>
    </Navbar>
);

export default AppNavbar;